import { render, staticRenderFns } from "./ControlCandle.vue?vue&type=template&id=6b2262e5&"
import script from "./ControlCandle.vue?vue&type=script&lang=js&"
export * from "./ControlCandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports